export default {
    loaded: "user.loaded",
    game: "user.game",
    games_tab: "user.games_tab",
    avatar: "user.avatar",
    balance: "user.balance",
    bets: "user.bets",
    favorites: {
        add: "user.favorites.add",
        remove: "user.favorites.remove"
    },
    toggleButton: "user.buttons.toggle",
    bonus_state: "user.bonus.state",
    logout: "user.logout"
}